import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  withStyles,
  Typography,
  Checkbox,
  InputLabel,
  IconButton,
  Button
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import VerifyRole from "../../../components/VerifyRole";
import * as CustomAccountActions from "../../../store/CustomAccountStore";
import * as SnackbarActions from "../../../store/SnackbarStore";
import { DeleteCustomAccount } from "../../../services/accountService";
import CustomAccountModal from "./components/CustomAccountModal";
import { UserRoleTypeEnum } from "../../../services/authService";
import ConfirmModal from "../../../components/ConfirmModal";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 1,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  filterLabel: {
    position: "relative",
    top: 1,
    marginRight: theme.spacing.unit * 1
  }
});

class CustomAccountApp extends Component {
  state = {
    filtered: false,
    customAccountModalOpen: false,
    showConfirmDelete: false,
    deleteCustomAccount: {}
  };

  componentDidMount() {
    const { requestCustomAccounts, requestAccountTypes } = this.props;
    requestCustomAccounts();
    requestAccountTypes();
  }

  handleModalClose = customAccount => {
    const { requestCustomAccounts } = this.props;
    if (customAccount) {
      requestCustomAccounts();
    }
    this.setState({ customAccountModalOpen: false });
  };

  addCustomAccount = () => {
    const { loadCustomAccountModal } = this.props;
    loadCustomAccountModal({
      id: 0,
      name: "",
      alias: "",
      active: true,
      exported: false
    });
    this.setState({ customAccountModalOpen: true });
  };

  editCustomAccount = id => {
    const { loadCustomAccountModal, customAccounts } = this.props;
    const customAccount = customAccounts.find(s => s.id === id);

    loadCustomAccountModal(customAccount);
    this.setState({ customAccountModalOpen: true });
  };

  showDeleteConfirmationModal = async account => {
    this.setState({
      showConfirmDelete: true,
      deleteCustomAccount: account
    });
  };

  handleDelete = async val => {
    const { requestCustomAccounts, sendError } = this.props;
    const { id } = this.state.deleteCustomAccount;

    try {
      await DeleteCustomAccount(id);
      requestCustomAccounts();
    } catch (error) {
      sendError(error);
    }
    this.setState({
      showConfirmDelete: false,
      deleteCustomAccount: {}
    });
  };

  handleCancelDelete = async id => {
    this.setState({
      showConfirmDelete: false,
      deleteCustomAccount: {}
    });
  };

  render() {
    const { classes, customAccounts } = this.props;

    let filteredCustomAccounts = customAccounts;
    if (this.state.filtered) {
      filteredCustomAccounts = customAccounts.filter(s => s.isActive);
    }

    return (
      <div>
        <Typography variant="h4" gutterBottom component="h2">
          CustomAccounts
        </Typography>
        <Checkbox
          checked={this.state.filtered}
          onChange={event => this.setState({ filtered: event.target.checked })}
        />
        <InputLabel className={classes.filterLabel}>Active Filter</InputLabel>
        <VerifyRole requiredRoles={[UserRoleTypeEnum.Administrator]}>
          <IconButton onClick={() => this.addCustomAccount()}>
            <AddIcon />
          </IconButton>
        </VerifyRole>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Number</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell align="center">Active</TableCell>
                <VerifyRole requiredRoles={[UserRoleTypeEnum.Administrator]}>
                  <TableCell align="center">Action</TableCell>
                </VerifyRole>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCustomAccounts.map(customAccount => (
                <TableRow key={customAccount.id}>
                  <TableCell component="th" scope="row">
                    {customAccount.number}
                  </TableCell>
                  <TableCell>{customAccount.name}</TableCell>
                  <TableCell>{customAccount.accountType.name}</TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={customAccount.isActive}
                      disabled={true}
                    />
                  </TableCell>
                  <VerifyRole requiredRoles={[UserRoleTypeEnum.Administrator]}>
                    <TableCell align="center">
                      <Button
                        onClick={() => this.editCustomAccount(customAccount.id)}
                      >
                        edit
                      </Button>
                      {!customAccount.exported && (
                        <IconButton
                          onClick={() =>
                            this.showDeleteConfirmationModal(customAccount)
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </VerifyRole>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
        {this.state.customAccountModalOpen && (
          <CustomAccountModal
            open={this.state.customAccountModalOpen}
            handleClose={this.handleModalClose}
          />
        )}
        {this.state.showConfirmDelete && (
          <ConfirmModal
            title="Delete Custom Account"
            message={`Are you sure you want to delete ${
              this.state.deleteCustomAccount.name
            }?`}
            handleOk={this.handleDelete}
            handleCancel={this.handleCancelDelete}
          />
        )}
      </div>
    );
  }
}

CustomAccountApp.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    customAccounts: state.customAccounts.customAccounts || []
  };
}

export default connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        CustomAccountActions.actionCreators,
        SnackbarActions.actionCreators
      ),
      dispatch
    )
)(withStyles(styles)(CustomAccountApp));
